
import React from "react";
import moment from "moment-timezone";
import { Row, Col, Card, OverlayTrigger, Tooltip, Image, Button, ListGroup, ListGroupItem } from '@themesberg/react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCogs, faDownload, faRocket, faPhone, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import BS5Logo from "../assets/img/technologies/bootstrap-5-logo.svg";
import GeotechLogo from "../assets/img/icons/geotechSquareLogoWithWhiteCircle_1X.png";
import LaravelLogo from "../assets/img/technologies/laravel-logo.svg";
import GitHubButton from 'react-github-btn';
import { Link } from 'react-router-dom';
import { Routes } from "../routes";
import { useSelector } from "react-redux";
import { getStatusLegend } from "../utils/statusLights";
import StatusLightSymbol from './StatusLightSymbol';

export default (props) => {
    const currentYear = moment().get("year");
    const showSettings = props.showSettings;
    const project = useSelector(state => state.project.joinedProjects.find(item => item.projectId === state.project.currentProjectId));

    const toggleSettings = (toggle) => {
        props.toggleSettings(toggle);
    }

    return (
        <div>
            {showSettings ? (
                <Card className="theme-settings">
                    <Card.Body className="pt-4">
                        <Button className="theme-settings-close" variant="close" size="sm" aria-label="Close" onClick={() => { toggleSettings(false) }} />
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <p className="m-0 mb-1 me-3 fs-7">圖例說明{/* <span role="img" aria-label="gratitude">💙</span>*/}</p>
                            {/*<GitHubButton href="https://github.com/themesberg/volt-react-dashboard" data-size="large" data-show-count="true" aria-label="Star themesberg/volt-react-dashboard on GitHub">Star</GitHubButton>*/}
                        </div>
                        {/*<Button href="https://themesberg.com/product/dashboard/volt-react" target="_blank" variant="primary" className="mb-3 w-100"><FontAwesomeIcon icon={faDownload} className="me-1" /> Test</Button>*/}
                        {/*<p className="fs-7 text-gray-700 text-center">Available in the following technologies:</p>*/}
                        <ListGroup aria-label="燈號圖例">
                            {getStatusLegend(project).map(light => (
                                <ListGroupItem key={light.color} className="d-flex align-items-center gap-2" data-status-color={light.color}>
                                    <span className="status-light-legend-sample"><StatusLightSymbol light={light} project={project} /></span>
                                    <span>{light.label}</span>
                                </ListGroupItem>
                            ))}
                        </ListGroup>
                        {/*<div className="d-flex justify-content-center">*/}
                            
                            {/*<OverlayTrigger placement="top" trigger={['hover', 'focus']} overlay={<Tooltip>(+886) 02-8647-1860</Tooltip>}>*/}
                            {/*    <Image src={BS5Logo} className="image image-xs" />*/}
                            {/*</OverlayTrigger>*/}
                            {/*    <Card.Link href="https://themesberg.com/product/admin-dashboard/volt-bootstrap-5-dashboard" target="_blank">*/}
                            {/*        <OverlayTrigger placement="top" trigger={['hover', 'focus']} overlay={<Tooltip>Bootstrap 5 · The most popular HTML, CSS, and JS library in the world.</Tooltip>}>*/}
                            {/*            <Image src={BS5Logo} className="image image-xs" />*/}
                            {/*        </OverlayTrigger>*/}
                            {/*    </Card.Link>*/}

                            {/*    <Card.Link href="https://themesberg.com/product/dashboard/volt-react" target="_blank">*/}
                            {/*        <OverlayTrigger placement="top" trigger={['hover', 'focus']} overlay={<Tooltip>React · A JavaScript library for building user interfaces.</Tooltip>}>*/}
                            {/*            <Image src={ReactLogo} className="image image-xs" />*/}
                            {/*        </OverlayTrigger>*/}
                            {/*    </Card.Link>*/}

                            {/*    <Card.Link href="https://themesberg.com/product/laravel/volt-admin-dashboard-template" target="_blank">*/}
                            {/*        <OverlayTrigger placement="top" trigger={['hover', 'focus']} overlay={<Tooltip>Laravel · Most popular PHP framework in the world.</Tooltip>}>*/}
                            {/*            <Image src={LaravelLogo} className="image image-xs" />*/}
                            {/*        </OverlayTrigger>*/}
                            {/*    </Card.Link>*/}

                        {/*</div>*/}
                    </Card.Body>
                </Card>
            ) : (
                <Card className="theme-settings theme-settings-expand" onClick={() => { toggleSettings(true) }}>
                    <Card.Body className="p-3 py-2">
                            <span className="fw-bold h6"><FontAwesomeIcon icon={faQuestionCircle} className="me-1 fs-7" /> 圖例說明</span>
                    </Card.Body>
                </Card>
            )}
            <footer className="footer section py-5">
                <Row className="d-flex justify-content-between align-items-center text-center text-lg-start">
                    <Col xs={12} lg="auto" className="mb-2 mb-lg-0">
                        <p className="mb-0">
                            <Card.Link href="http://www.geotech-science.com" target="_blank" className="text-blue text-decoration-none fw-normal">
                                <Image alt="Geotech" src={GeotechLogo} className="image image-md" style={{ marginBottom: '22px' }}></Image>-Science Co., Ltd.
                            </Card.Link> © 1993-{`${currentYear}` + " 捷儀科技"}
                            <a href="http://www.geotech-science.com" target="_blank"></a>
                        </p>
                    </Col>
                    <Col xs={12} lg="auto" className="text-center text-lg-end">
                        <p className="mb-0">
                            {"Fullstack developed by "}
                            <Card.Link href="http://hollen9.com" target="_blank" className="text-blue text-decoration-none fw-normal">
                                Hollen9.com
                            </Card.Link>
                        </p>
                    </Col>

                    {/*<Col xs={12} lg={6}>*/}
                    {/*    <ul className="list-inline list-group-flush list-group-borderless text-center text-xl-right mb-0">*/}
                    {/*        */}{/*<li className="list-inline-item px-0 px-sm-2">*/}
                    {/*        */}{/*  <Card.Link href="https://themesberg.com/about" target="_blank">*/}
                    {/*        */}{/*    About*/}
                    {/*        */}{/*  </Card.Link>*/}
                    {/*        */}{/*</li>*/}
                    {/*        */}{/*<li className="list-inline-item px-0 px-sm-2">*/}
                    {/*        */}{/*  <Card.Link href="https://themesberg.com/themes" target="_blank">*/}
                    {/*        */}{/*    Themes*/}
                    {/*        */}{/*  </Card.Link>*/}
                    {/*        */}{/*</li>*/}
                    {/*        <li className="list-inline-item px-0 px-sm-2">*/}
                    {/*            <Card.Link href="http://dns1.geotech-science.com/webchart/" target="_blank">*/}
                    {/*                舊版監測網頁*/}
                    {/*            </Card.Link>*/}
                    {/*        </li>*/}
                    {/*        <li className="list-inline-item px-0 px-sm-2">*/}
                    {/*            <Card.Link href="http://www.geotech-science.com/" target="_blank">*/}
                    {/*                捷儀官網*/}
                    {/*            </Card.Link>*/}
                    {/*        </li>*/}
                    {/*    </ul>*/}
                    {/*</Col>*/}
                </Row>
            </footer>
        </div>
    );
};
